import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiFetch } from '../lib/api.js';
import { setActiveOrgId } from '../lib/activeOrg.js';
import { C } from '../lib/theme.js';
import { Eyebrow } from '../ui/ui.js';
import type { OrgSummary } from '../lib/types.js';

export function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState<'working' | 'done' | 'error'>('working');
  const [org, setOrg] = useState<OrgSummary | null>(null);
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard against StrictMode double-invoke (token is single-use)
    ran.current = true;

    if (!token) {
      setStatus('error');
      setMessage('No invite token in the link.');
      return;
    }
    apiFetch<OrgSummary>('/api/invites/accept', {
      method: 'POST',
      body: JSON.stringify({ token }),
    })
      .then((o) => {
        setOrg(o);
        setActiveOrgId(o.id);
        setStatus('done');
      })
      .catch((err: unknown) => {
        setStatus('error');
        setMessage(err instanceof Error ? err.message : 'Could not accept the invite.');
      });
  }, [token]);

  const link = { color: C.basil, textDecoration: 'none' } as const;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div style={{ width: 'min(400px,100%)' }}>
        <Eyebrow style={{ marginBottom: 10 }}>Invitation</Eyebrow>
        <h1 className="page-title" style={{ marginBottom: 14 }}>
          Accept invite
        </h1>
        {status === 'working' && <p style={{ color: C.muted, fontSize: 14 }}>Joining…</p>}
        {status === 'done' && (
          <p style={{ color: C.secondary, fontSize: 14, lineHeight: 1.6 }}>
            You&rsquo;ve joined <span style={{ color: C.primary }}>{org?.name}</span>.{' '}
            <Link to="/" style={link}>
              Go to Basil →
            </Link>
          </p>
        )}
        {status === 'error' && (
          <p style={{ color: C.act, fontSize: 14, lineHeight: 1.6 }}>
            {message}{' '}
            <Link to="/" style={link}>
              Back to Basil
            </Link>
          </p>
        )}
      </div>
    </div>
  );
}
